import LAYOUT from '@/layouts/default/index.vue';
// 中转页面
export default {
  path: '/skipH5',
  component: LAYOUT,
  name: 'Skip',
  redirect: '/skipH5/index',
  meta: {
    title: '北京汽车',
  },
  children: [
    {
      path: 'index',
      name: 'SkipIndex',
      meta: {
        title: '北京汽车',
      },
      component: () => import('@/views/skip/index'),
    },
  ],
};
